const default_page_row: any = {
  key: "",
  memo_key: "",
  title: "",
  minHeight: "100px",
  h_ratio: 1,
  th_text_style:{},
};
const content_page_data_arr: any = [
  {
    page_num_str: "01",
    title: "학습 태도 (학생 평가서 기준)",
    memo: "비고",
    arr: [
      {
        ...default_page_row,
        key: "a_att_obs_result",
        memo_key: "a_att_obs_result_memo",
        title: ("1.\n관찰\n결과"),
        h_ratio: 1.5,
      },
      {
        ...default_page_row,
        key: "a_att_interpret",
        memo_key: "a_att_interpret_memo",
        title: ("2.\n태도\n해석"),
        h_ratio: 1,
      },
      {
        ...default_page_row,
        key: "a_att_learning_mean",
        memo_key: "a_att_learning_mean_memo",
        title: ("3.\n학습적\n의미"),
        h_ratio: 1,
      },
      {
        ...default_page_row,
        key: "a_att_teaching_point",
        memo_key: "a_att_teaching_point_memo",
        title: ("4.\nTeaching\nPoint"),
        h_ratio: 1,
      },
    ],
  },
  {
    page_num_str: "02",
    title: "학습 성향분석( RUTA 유형)",
    memo: "비고",
    arr: [
      {
        ...default_page_row,
        key: "a_type_analysis",
        memo_key: "a_type_analysis_memo",
        title: ("1.\n유형\n분석"),
        h_ratio: 1.5,
      },
      {
        ...default_page_row,
        key: "a_type_strength",
        memo_key: "a_type_strength_memo",
        title: ("2.\n유형\n강점"),
        h_ratio: 1,
      },
      {
        ...default_page_row,
        key: "a_type_caution",
        memo_key: "a_type_caution_memo",
        title: ("3.\n주의\n부분"),
        h_ratio: 1,
      },
      {
        ...default_page_row,
        key: "a_type_growth_direction",
        memo_key: "a_type_growth_direction_memo",
        title: ("4.\n성장\n방향"),
        h_ratio: 1,
      },
    ],
  },
  {
    page_num_str: "03",
    title: "수학 영역별 진단 테스트 결과",
    memo: "비고",
    arr: [
      {
        ...default_page_row,
        key: "a_res_score_range",
        memo_key: "a_res_score_range_memo",
        title: ("1.\n평가\n범위\n및\n점수"),
        h_ratio: 1.5,
      },
      {
        ...default_page_row,
        key: "a_res_unit_analysis",
        memo_key: "a_res_unit_analysis_memo",
        title: ("2.\n단원별\n분석"),
        h_ratio: 1,
      },
      {
        ...default_page_row,
        key: "a_res_final_analysis",
        memo_key: "a_res_final_analysis_memo",
        title: ("3.\n최종\n분석"),
        h_ratio: 1,
      },
      {
        ...default_page_row,
        key: "a_res_guide_direction",
        memo_key: "a_res_guide_direction_memo",
        title: ("4.\n지도\n방향"),
        h_ratio: 1,
      },
    ],
  },
  {
    page_num_str: "04",
    title: "수리 수행력 평가 분석",
    memo: "비고",
    arr: [
      {
        ...default_page_row,
        key: "a_do_evaluation",
        memo_key: "a_do_evaluation_memo",
        title: ("1.\n평가\n분석"),
        h_ratio: 3,
      },
      {
        ...default_page_row,
        key: "a_do_level",
        memo_key: "a_do_level_memo",
        title: ("2.\n레벨\n지정"),
        h_ratio: 1,
      },
    ],
  },
  {
    page_num_str: "",
    title: "학습처방 입학테스트 최종 분석",
    memo: "비고",
    is_result_page: true,
    arr: [
      {
        ...default_page_row,
        key: "a_pres_overall_comment",
        memo_key: "a_pres_overall_comment_memo",
        title: ("1.\n총평"),
        h_ratio: 3,
        th_text_style: { fontSize: "20px" },
      },
      {
        ...default_page_row,
        key: "a_pres_weekly_plan",
        memo_key: "a_pres_weekly_plan_memo",
        title: ("2.\n수업\n내용\none\nweek\nprogram"),
        h_ratio: 1,
        th_text_style: { fontSize: "18px" },
      },
    ],
  },
];
export default content_page_data_arr;